module.exports = __webpack_public_path__ + "static/HKGrotesk-Regular-e362f79bc288a9f9ea7bba040757acd3.woff";